import classNames from 'classnames';
import React from 'react';
import { Wrapper } from './styled';
import styles from './styles.module.scss';

const Tooltip = ({
  content,
  children,
  className,
  position = 'bottom',
  color = '#27198D'
}) => {
  const [show, setShow] = React.useState(false);

  const handleMouseIn = () => {
    setShow(true);
  };

  const handleMouseOut = () => {
    setShow(false);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.tooltip, className),
    onMouseOver: handleMouseIn,
    onMouseLeave: handleMouseOut
  }, show && /*#__PURE__*/React.createElement(Wrapper, {
    color: color,
    className: classNames(styles['tooltip-content'], styles[position])
  }, content), children);
};

export default Tooltip;